import axios, { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useAxios, apiEndpoints } from 'api';
import { AutoAlertStatus } from 'components';
import { UserEmployeeInfo } from 'api/types';
import {
  MedicalExaminationEmployee,
  MedicalExaminationEmployeeAdditionalParam,
  MedicalExaminationUpcoming,
} from 'api/types/MedicalEmployee';

const useGetMedicalExamination = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: MedicalExaminationEmployeeAdditionalParam) => void,
  MedicalExaminationEmployee[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    MedicalExaminationEmployee[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: MedicalExaminationEmployeeAdditionalParam) => {
      ax.get<MedicalExaminationEmployee[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/medical/current`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

const useGetMedicalExaminationUpcoming = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: MedicalExaminationEmployeeAdditionalParam) => void,
  MedicalExaminationUpcoming | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    MedicalExaminationUpcoming | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: MedicalExaminationEmployeeAdditionalParam) => {
      ax.get<MedicalExaminationUpcoming>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/medical/upcoming`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

export default {
  useGetMedicalExamination,
  useGetMedicalExaminationUpcoming,
};
